// extracted by mini-css-extract-plugin
export default {"root":"ListingsCarousel_root__WLlm2","listings":"ListingsCarousel_listings__Y1oi0"};